import { TableCell, TableRow } from "@mui/material"
import React from "react"

const LeaderboardRow = ({ teamRow, setSelectedTeamId }) => {
    return (
        <TableRow sx={{
            transition: 'all 0.3s ease',
            '&:hover': {
                background: 'rgba(218, 165, 32, 0.15)',
            }
        }}>
            <TableCell sx={{
                p: 1,
                fontFamily: "'Philosopher', sans-serif",
                color: '#FFD700',
                fontWeight: 600,
                textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.7)',
                borderBottom: '0.1rem solid rgba(218, 165, 32, 0.3)',
            }}>
                {teamRow.teamName}
            </TableCell>
            <TableCell sx={{
                p: 1,
                fontFamily: "'Philosopher', sans-serif",
                color: '#FFA500',
                fontWeight: 600,
                borderBottom: '0.1rem solid rgba(218, 165, 32, 0.3)',
            }}>
                {teamRow.totalCredits}
            </TableCell>
            <TableCell sx={{
                p: 1,
                fontFamily: "'Philosopher', sans-serif",
                color: '#FFA500',
                fontWeight: 600,
                borderBottom: '0.1rem solid rgba(218, 165, 32, 0.3)',
            }}>
                {teamRow.percentage}%
            </TableCell>
            <TableCell sx={{
                p: 1,
                borderBottom: '0.1rem solid rgba(218, 165, 32, 0.3)',
            }}>
                <div
                    role="button"
                    onClick={() => setSelectedTeamId(teamRow)}
                    style={{
                        color: '#90EE90',
                        fontFamily: "'Cinzel', serif",
                        fontWeight: 700,
                        cursor: 'pointer',
                        textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.8)',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#32CD32';
                        e.currentTarget.style.textDecoration = 'underline';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = '#90EE90';
                        e.currentTarget.style.textDecoration = 'none';
                    }}
                >
                    Edit
                </div>
            </TableCell>
        </TableRow>
    )
}

export default LeaderboardRow;